<template>
  <div class="distribution-page">
    <top-bar :topbarList="distributionTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";

import { distributionIndexMixins } from "@/mixins/distributionIndexMixins";

export default {
  mixins: [distributionIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.distribution-page {
  height: 100%;
}
</style>
